module.exports = __webpack_public_path__ + "img/lapiz-copy-3.8da5cba4.svg";